import { render } from "./BusinessSection.vue?vue&type=template&id=4ad12851"
import script from "./BusinessSection.vue?vue&type=script&lang=js"
export * from "./BusinessSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/unipar/Code/neo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__